/**
 * Normalize any date-ish value to ISO YYYY-MM-DD.
 * Accepts MM/DD/YYYY, ISO date, ISO datetime (with or without Z), Date object.
 * Returns '' on null/undefined/'', unrecognized formats, or invalid dates.
 */
export function normalizeToIsoDate(value) {
  if (value == null || value === '') return '';

  if (value instanceof Date) {
    if (isNaN(value.getTime())) return '';
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  if (typeof value !== 'string') return '';
  const s = value.trim();
  if (!s) return '';

  const tIdx = s.indexOf('T');
  if (tIdx >= 0) {
    const datePart = s.slice(0, tIdx);
    return isValidIso(datePart) ? datePart : '';
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return isValidIso(s) ? s : '';
  }

  const slash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slash) {
    const [, m, d, y] = slash;
    const iso = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    return isValidIso(iso) ? iso : '';
  }

  return '';
}

/**
 * Convert ISO YYYY-MM-DD to MM/DD/YYYY for ACORD PDF output.
 * Returns '' on falsy or unrecognized input.
 */
export function formatIsoToAcord(iso) {
  if (!iso) return '';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';
  const [, y, mm, dd] = m;
  return `${mm}/${dd}/${y}`;
}

function isValidIso(iso) {
  const parts = iso.split('-').map(Number);
  if (parts.length !== 3) return false;
  const [y, m, d] = parts;
  if (!y || !m || !d) return false;
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;
  return true;
}
